import toast from "react-hot-toast"
import { apiConnector } from "../apiconnector"
import { materialEndpoints } from "../apis"

const {
  ADD_MATERIAL_API,
  DELETE_MATERIAL_API,
  GET_COURSE_MATERIALS_API,
  DOWNLOAD_MATERIAL_API,
} = materialEndpoints

export const getCourseMaterials = async (courseId, token) => {
  let result = []

  try {
    const response = await apiConnector(
      "POST",
      GET_COURSE_MATERIALS_API,
      { courseId },
      { Authorization: `Bearer ${token}` }
    )

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    result = response.data.data
  } catch (error) {
    console.log("GET MATERIALS API ERROR....", error)
    toast.error(error.response?.data?.message || "Could not load materials")
  }

  return result
}

export const addMaterial = async (formData, token) => {
  const toastId = toast.loading("Uploading...")
  let success = false

  try {
    const response = await apiConnector("POST", ADD_MATERIAL_API, formData, {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    })

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    //dismissed before the result is shown, otherwise the spinner toast sits on
    //top of the confirmation and the upload looks like it did nothing
    toast.dismiss(toastId)

    const title = formData?.get?.("title")
    toast.success(title ? `"${title}" uploaded` : "Material uploaded")
    success = true
  } catch (error) {
    console.log("ADD MATERIAL API ERROR....", error)
    toast.dismiss(toastId)
    toast.error(error.response?.data?.message || "Could not upload the material")
  }

  return success
}

export const deleteMaterial = async (courseId, materialId, token) => {
  const toastId = toast.loading("Deleting...")
  let success = false

  try {
    const response = await apiConnector(
      "DELETE",
      DELETE_MATERIAL_API,
      { courseId, materialId },
      { Authorization: `Bearer ${token}` }
    )

    if (!response?.data?.success) {
      throw new Error(response?.data?.message)
    }

    toast.dismiss(toastId)
    toast.success("Material deleted")
    success = true
  } catch (error) {
    console.log("DELETE MATERIAL API ERROR....", error)
    toast.dismiss(toastId)
    toast.error(error.response?.data?.message || "Could not delete the material")
  }

  return success
}

//The server streams the file rather than handing over a storage link, so the
//download has to go through axios with the auth header and be turned back into
//a file here. A plain anchor tag would carry no token and be rejected.
export const downloadMaterial = async (courseId, material, token) => {
  const toastId = toast.loading("Preparing download...")

  try {
    const response = await apiConnector(
      "GET",
      DOWNLOAD_MATERIAL_API(courseId, material._id),
      null,
      { Authorization: `Bearer ${token}` },
      null,
      "blob"
    )

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", material.originalName || material.title)
    document.body.appendChild(link)
    link.click()

    link.remove()
    //the object url holds the whole file in memory until it is released
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.log("DOWNLOAD MATERIAL API ERROR....", error)
    toast.error("Could not download the file")
  }

  toast.dismiss(toastId)
}
